import { useTranslation } from 'next-i18next';

import { ChangeEvent, useCallback } from 'react';

import { Input } from '@nocowanie/common-ui';
import { IconsLinear } from '@nocowanie/icons';

import { ReviewsSearchProps } from './reviews-search.props';

export const ReviewsSearch = ({ query, onQueryChange, ...rest }: ReviewsSearchProps) => {
    const { t } = useTranslation('accommodation', {
        keyPrefix: 'reviews',
    });

    const onClearClick = useCallback(() => {
        setTimeout(() => {
            onQueryChange('');
        }, 0);
    }, [onQueryChange]);

    const onChange = useCallback(
        (event: ChangeEvent<HTMLInputElement>) => {
            onQueryChange(event.currentTarget.value);
        },
        [onQueryChange],
    );

    return (
        <Input
            leftIcon={<IconsLinear.Search size="sm" color={'secondary.solid'} />}
            isClearable={!!query.length}
            inputProps={{
                placeholder: t('search.placeholder'),
                value: query,
                onChange,
                'data-testid': 'review-search',
            }}
            onClearClick={onClearClick}
            clearButtonProps={{
                'data-testid': 'review-search-clear',
            }}
            {...rest}
        />
    );
};
